@if (breakpointChanges | async; as breakpointState) {
  <button tdWbIconButton
          [tdWbIconButtonShape]="breakpointState.matches && autoSizeOverride() ? 'circle' : 'square'"
          tdWbIconButtonSize="small"
          [tdWbIconButtonBackground]="(breakpointState.matches && autoSizeOverride() ? 'clear' : tdWbIconButtonBackground())"
          [attr.title]="'tdWb.component.toolbar.REFRESH' | tdWbTranslate"
          [attr.aria-label]="'tdWb.component.toolbar.REFRESH' | tdWbTranslate"
          (click)="refresh()">
    <td-wb-icon size="18"
                iconId="reload--small" />
  </button>
}
